module.exports = __webpack_public_path__ + "img/move01.dcdb079d.jpg";